//トップページ　キービジュアルスライダー
import slick from 'slick-carousel';
import gsap from 'gsap';
import {
  ScrollTrigger
} from "gsap/ScrollTrigger";
import {
  ScrollToPlugin
} from "gsap/ScrollToPlugin";
gsap.registerPlugin(ScrollTrigger, ScrollToPlugin);

export function idxFunc() {
  let indexPage = $('#indexTop').length;

  if (indexPage) {
    let resizecheck = $('#responsibleCheck').width();
    const wait = ms => new Promise(resolve => setTimeout(() => resolve(), ms));

      //メインビュー
      wait(0)
      .then(() => {
          $('.fv .fvBg').addClass('active');
          return wait(400)
      })
      .then(() => {
          $('.fv .fvImg02').addClass('active');
          return wait(400)
      })
      .then(() => {
          $('.fv .fvImg01').addClass('active');
          return wait(400)
      })
      .then(() => {
        $('.fv .fvImg00').addClass('active');
          return wait(800)
      })
      .then(() => {
          $('.fv .logoImg').addClass('active');
          $('.fv .fvTit').addClass('active');
          $('.fv .fvCopyRight').addClass('active');
          return wait(500)
      })

    window.addEventListener('resize', () => {
      resizecheck = $('#responsibleCheck').width();
    
      //アコーディオン初期化
      slideStart();
    }, false);

    var slideStart = function () {
      $('.slideArea').each(function (i) {
        var $_t = $(this);
        let slideClass = $_t.addClass('slide' + i)
    
        //スライダー部分
        if (resizecheck == '2') {
          slideClass.not('.slick-initialized').slick({
            autoplay: true,
            autoplaySpeed: 10000,
            speed: 800,
            centerMode:true,
            prevArrow: '<img src="/s/garrack/feature/evangelion2026/images/common/slide_arrow_prev.svg" class="slide-arrow prev-arrow">',
            nextArrow: '<img src="/s/garrack/feature/evangelion2026/images/common/slide_arrow_next.svg" class="slide-arrow next-arrow">',
          });
        }else{
          $('.slide' + i + ".slick-initialized").slick('unslick');
        }
      });
    }
    var animationStart = function () {
      $('.animation').each(function () {
        var position = $(this).offset().top;
        var scroll = $(window).scrollTop();
        var windowHeight = $(window).height();
        
        if (scroll > position - windowHeight + 60) {
          $(this).addClass('active');
        }
      });
    }

    slideStart();
    animationStart();

    var idxScrollFunc = function () {
      let trigger = document.getElementById("indexTop");
      let fixContent = $('#fixidContent');
      
      let triggerEnd = document.getElementById("shopList");
    
      let scrollValue = $(window).scrollTop();
      let clientRect = trigger.getBoundingClientRect();
      let clientRectEnd = triggerEnd.getBoundingClientRect();
      let py = window.pageYOffset + clientRect.top;
      let ey = window.pageYOffset + clientRectEnd.top;
    
      if (py < scrollValue && ey > scrollValue + window.innerHeight) {
        fixContent.addClass('show');
      } else {
        fixContent.removeClass('show');
      }
    }

    idxScrollFunc();

    $(window).on('scroll', function () {
      animationStart();
      idxScrollFunc();
    });

    let panels = gsap.utils.toArray(".panel");
    let tops = panels.map(panel => ScrollTrigger.create({trigger: panel, start: "top top"}));

    panels.forEach((panel, i) => {
      ScrollTrigger.create({
        trigger: panel,
        start: () => panel.offsetHeight < window.innerHeight ? "top top" : "bottom bottom",
        pin: true, 
        pinSpacing: false 
      });
    });
  }
}